/**
 * Baidu Tongji — self-registering.
 */

import { warn } from '../../util/log';
import type { BaiduPixel } from '../../core/config/types';
import { on, SdkEvent } from '../../core/events/bus';
import type { PixelRegister } from './types';

declare global {
  interface Window {
    _hmt?: unknown[];
  }
}

const scriptInjectedFor = new Set<string>();

function ensureHmt(pixel: BaiduPixel): void {
  if (typeof window === 'undefined') return;
  if (!Array.isArray(window._hmt)) window._hmt = [];
  if (scriptInjectedFor.has(pixel.pixel_id)) return;
  scriptInjectedFor.add(pixel.pixel_id);
  try {
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://hm.baidu.com/hm.js?${encodeURIComponent(pixel.pixel_id)}`;
    (document.head || document.documentElement).appendChild(s);
  } catch (err) {
    warn('baidu script inject failed', err);
  }
}

// NOTE: `_hmt` pushes are global — Baidu Tongji has no per-pixel scoping, so
// multiple Baidu pixels on one page would multiply events.
export const registerBaidu: PixelRegister<BaiduPixel> = (pixel, context) => {
  on(SdkEvent.PAGE_VIEW, () => {
    if (context.getConsent() !== 'granted') return;
    ensureHmt(pixel);
  });

  on(SdkEvent.ECOM_CLICKOUT, ({ advertiserCampaignId, productId }) => {
    if (context.getConsent() !== 'granted') return;
    try {
      ensureHmt(pixel);
      window._hmt!.push(['_trackEvent', 'lead', 'click', advertiserCampaignId ?? productId ?? '']);
    } catch (err) {
      warn('baidu clickout failed', err);
    }
  });
};

export function _resetBaiduForTests(): void {
  scriptInjectedFor.clear();
}
